<template>
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.79066 0L1.7123 6.79627V10.2661H3.20287V7.79019H8.87634V1.44923H20.7934V10.2664H22.2862V0.000575287L7.79066 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20285 20.8524H20.7934V25.5521L3.20285 25.5332V20.8524ZM15.4119 13.2596H20.2288V14.2624H18.4363V19.0081H17.1977V14.2624H15.4122L15.4119 13.2596ZM9.47082 13.2596H10.9358L12.0059 15.1209L13.0852 13.2596H14.5205L12.7192 16.0197L14.6465 19.0086H13.1375L12.0059 17.0341L10.8099 19.0086H9.36538L11.283 16.073L9.47082 13.2596ZM8.58641 13.2596V14.2624H6.79391V19.0081H5.55522V14.2624H3.7698L3.76954 13.2596H8.58641ZM0 11.4132V20.8518H1.71175V26.9825L22.2857 27V20.8523H24V11.4131L0 11.4132Z"
      fill="currentcolor"
    />
  </svg>
</template>
